<mat-button-toggle-group appearance="legacy" [value]="value">
  <mat-button-toggle value="full" (click)="setCardLayout.emit('full')"
    ><mat-icon>view_headline</mat-icon></mat-button-toggle
  >
  <mat-button-toggle value="minimal" (click)="setCardLayout.emit('minimal')"
    ><mat-icon>view_column</mat-icon></mat-button-toggle
  >
</mat-button-toggle-group>
